<script lang="ts" setup>
import { ref, watch } from 'vue';

const $emit = defineEmits<{
  (event: 'change', value: boolean): void;
  (event: 'update', value: boolean): void;
  (event: 'update:modelValue', value: boolean): void;
  (event: 'close'): void;
}>();

const $props = defineProps<{
  modelValue: boolean;
  title?: string;
  modal?: boolean;
}>();

const visible = ref($props.modelValue);

watch(
  () => $props.modelValue,
  (newVal: boolean) => {
    visible.value = newVal;
  },
);
const handleClose = () => {
  $emit('change', false);
  $emit('update:modelValue', false);
  $emit('close');
};
</script>

<template>
  <x-dialog
    v-model="visible"
    width="770px"
    :title="$props.title"
    :before-close="handleClose"
    :close-on-click-modal="false"
    :modal="$props.modal"
    @close="handleClose"
  >
    <slot></slot>
  </x-dialog>
</template>
